"use strict";

angular.module('rmStationSettings')
    .factory('FieldTypes', require('./fieldtypes.js'))
;